import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, Navigate, useParams } from 'react-router-dom';
import { policyBySlug } from './content/siteCopyHelpers';
import { useSiteSettings } from './SiteSettingsContext';

export default function PolicyPage() {
  const { slug } = useParams();
  const { settings: site } = useSiteSettings();
  const policy = policyBySlug(slug, site.policies);
  const storeCopy = site.store_copy || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!policy) {
    return <Navigate to="/404" replace />;
  }

  const footerNote = String(storeCopy.policy_page_footer || '').trim();

  return (
    <div className="store-page policy-page">
      <Helmet>
        <title>{`${policy.title} | Saloni Designs`}</title>
        <meta name="description" content={policy.seoDescription} />
      </Helmet>
      <div className="container store-page__container py-4 py-lg-5">
        <nav className="policy-page__crumb small mb-3" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden> / </span>
          <span>{policy.title}</span>
        </nav>
        <header className="store-page__header mb-4">
          <h1 className="store-page__title">{policy.title}</h1>
          {storeCopy.policy_page_lead ? (
            <p className="store-page__lead mb-0">{storeCopy.policy_page_lead}</p>
          ) : null}
        </header>
        <div className="policy-page__body">
          {policy.sections.map((sec) => (
            <section key={sec.heading} className="policy-page__section">
              <h2 className="policy-page__heading">{sec.heading}</h2>
              <p className="policy-page__text">{sec.body}</p>
            </section>
          ))}
        </div>
        <p className="small text-muted mt-4 mb-0">
          {footerNote || (
            <>
              Questions? <Link to="/contact">Contact us</Link> or message us on WhatsApp.
            </>
          )}
        </p>
      </div>
    </div>
  );
}
